import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
export const LP_BADGE_VARIANTS = {
    variant: [
        "primary",
        "secondary",
        "error",
        "warning",
        "success",
        "destructive",
        "info",
        "beta",
        "outline",
        "red",
        "green",
        "neutral",
        "orange",
        "purple",
        "teal",
        "teal-subtle",
        "blue",
    ],
    appearance: ["filled", "dot"],
};
export const LP_BADGE_DEFAULT_VARIANTS = {
    variant: "primary",
    appearance: "filled",
};
const badgeManagedAttrs = [
    "data-lp-component",
    "class",
    "data-variant",
    "data-appearance",
];
const dotVariants = new Set(["success", "warning", "error", "neutral"]);
export function LpBadge({ children, variant = LP_BADGE_DEFAULT_VARIANTS.variant, appearance = LP_BADGE_DEFAULT_VARIANTS.appearance, className, attributes, }) {
    const hasDot = appearance === "dot" && dotVariants.has(variant);
    return html `
        <span
            data-lp-component="Badge"
            class="${cn("lp-badge", className, attributes?.class)}"
            ${attr("data-variant", variant)}
            ${attr("data-appearance", appearance)}
            ${spreadAttrs(attributes, { omit: badgeManagedAttrs })}
        >
            ${hasDot
        ? html `<span class="lp-badge_dot" aria-hidden="true"></span>`
        : ""}
            ${children}
        </span>
    `;
}
